// id strings for messages/auth.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const auth: Dict = {
  // Shared
  "auth.continueGoogle": "Lanjut dengan Google",
  "auth.orEmail": "atau dengan email",
  "auth.email": "Email",
  "auth.emailInput": "Kolom email",
  "auth.emailPlaceholder": "kamu@contoh.com",
  "auth.password": "Kata sandi",
  "auth.passwordInput": "Kolom kata sandi",
  "auth.passwordPlaceholderNew": "Minimal 6 karakter",
  "auth.signUp": "Daftar",
  "auth.logIn": "Masuk",
  "auth.signIn": "Masuk",
  "auth.createAccount": "Buat akun",
  "auth.createYourAccount": "Buat akunmu",
  "auth.forgotPassword": "Lupa kata sandi?",
  "auth.agree": "Saya setuju dengan",
  "auth.agreeJammable": "Saya setuju dengan",
  "auth.and": "dan",
  "auth.terms": "Ketentuan Penggunaan",
  "auth.privacy": "Kebijakan Privasi",
  "auth.agreeRequired":
    "Harap setujui Ketentuan Penggunaan dan Kebijakan Privasi kami.",
  "auth.welcomeBack": "Selamat datang kembali!",
  "auth.welcomeNew": "Selamat datang di Jammable!",
  "auth.registerError": "Terjadi kesalahan saat mendaftar. Coba lagi, ya.",
  "auth.backToLogin": "Kembali ke halaman masuk",

  // Form validation
  "auth.invalidEmail": "Email tidak valid",
  "auth.emailRequired": "Email wajib diisi",
  "auth.passwordMin": "Kata sandi minimal 6 karakter",
  "auth.passwordRequired": "Kata sandi wajib diisi",

  // SignInModal
  "auth.modal.signInTitle": "Masuk ke Jammable",
  "auth.modal.subtitle": "Bikin cover AI dengan 100.000+ suara.",
  "auth.modal.signUpButton": "Tombol daftar",
  "auth.modal.signInButton": "Tombol masuk",
  "auth.modal.haveAccount": "Sudah punya akun?",
  "auth.modal.newHere": "Baru di sini?",
  "auth.modal.createAnAccount": "Buat akun",

  // /login
  "auth.login.heading": "Selamat datang kembali",
  "auth.login.blurb":
    "Cover, suara, dan koleksimu masih ada di tempat yang sama.",
  "auth.login.noAccount": "Belum punya akun?",

  // /signup
  "auth.signup.heading": "Bikin suara apa pun menyanyikan",
  "auth.signup.headingHighlight": "audiomu",
  "auth.signup.blurb":
    "100.000+ suara, semua covermu tersimpan di satu tempat, dan studio untuk duet dan video.",
  "auth.signup.haveAccount": "Sudah punya akun?",

  // /forgotpassword
  "auth.forgot.title": "Reset kata sandimu",
  "auth.forgot.blurb":
    "Masukkan emailmu dan kami akan kirim link untuk membuat kata sandi baru.",
  "auth.forgot.send": "Kirim link reset",
  "auth.forgot.sentToast": "Email reset kata sandi sudah dikirim!",
  "auth.forgot.sent": "Terkirim. Cek kotak masuk dan folder spam kamu.",
  "auth.forgot.google": "Daftar pakai Google?",
  "auth.forgot.googleAfter": "saja",

  // /resetpassword
  "auth.reset.title": "Buat kata sandi baru",
  "auth.reset.blurb":
    "Minimal 6 karakter. Selanjutnya kamu masuk dengan kata sandi ini.",
  "auth.reset.newPassword": "Kata sandi baru",
  "auth.reset.submit": "Reset kata sandi",
  "auth.reset.success": "Kata sandi berhasil direset!",
  "auth.reset.expired": "Link kedaluwarsa?",
  "auth.reset.sendNew": "Kirim yang baru",

  // Firebase errors: Google popup
  "auth.error.google.popup-closed-by-user":
    "Jendela popup ditutup sebelum proses masuk selesai. Coba lagi, ya.",
  "auth.error.google.popup-blocked":
    "Jendela popup diblokir oleh browser. Aktifkan popup lalu coba lagi.",
  "auth.error.google.operation-not-supported-in-this-environment":
    "Metode masuk ini tidak didukung di perangkat atau browser yang kamu pakai.",
  "auth.error.google.network-request-failed":
    "Terjadi gangguan jaringan. Cek koneksi internetmu lalu coba lagi.",
  "auth.error.google.cancelled-popup-request":
    "Terdeteksi beberapa permintaan masuk sekaligus. Coba lagi, ya.",
  "auth.error.google.timeout":
    "Proses masuk terlalu lama. Cek koneksi internetmu lalu coba lagi.",
  "auth.error.google.account-exists-with-different-credential":
    "Sudah ada akun dengan alamat email ini. Masuk dengan metode yang benar.",
  "auth.error.google.invalid-credential":
    "Kredensial masuk tidak valid atau sudah kedaluwarsa. Coba lagi, ya.",
  "auth.error.google.user-disabled":
    "Akunmu telah dinonaktifkan. Hubungi tim dukungan untuk bantuan.",
  "auth.error.google.user-not-found":
    "Tidak ada akun dengan alamat email ini. Coba lagi atau daftar akun baru.",
  "auth.error.google.wrong-password": "Kata sandi salah. Coba lagi, ya.",

  // Firebase errors: email sign-in
  "auth.error.signIn.invalid-email":
    "Alamat email yang kamu masukkan tidak valid. Cek lagi lalu coba ulang.",
  "auth.error.signIn.user-disabled":
    "Akunmu telah dinonaktifkan. Hubungi tim dukungan untuk bantuan.",
  "auth.error.signIn.user-not-found":
    "Tidak ada akun dengan alamat email ini. Coba lagi atau daftar akun baru.",
  "auth.error.signIn.wrong-password":
    "Kata sandi yang kamu masukkan salah. Coba lagi, ya.",
  "auth.error.signIn.too-many-requests":
    "Terlalu banyak percobaan masuk yang gagal. Coba lagi nanti.",

  // Firebase errors: email sign-up
  "auth.error.signUp.email-already-in-use":
    "Alamat email ini sudah dipakai akun lain. Gunakan email yang berbeda.",
  "auth.error.signUp.invalid-email":
    "Alamat email yang kamu masukkan tidak valid. Cek lagi lalu coba ulang.",
  "auth.error.signUp.operation-not-allowed":
    "Pembuatan akun baru sedang tidak tersedia. Coba lagi nanti.",
  "auth.error.signUp.weak-password":
    "Kata sandi minimal 6 karakter. Coba kata sandi yang lebih kuat.",

  // Firebase errors: sending the reset email
  "auth.error.forgot.invalid-email": "Masukkan alamat email yang valid.",
  "auth.error.forgot.user-not-found": "Tidak ada akun dengan email ini.",
  "auth.error.forgot.missing-android-pkg-name":
    "Nama paket Android wajib diisi.",
  "auth.error.forgot.missing-continue-uri": "URL lanjutan wajib diisi.",
  "auth.error.forgot.missing-ios-bundle-id": "Bundle ID iOS wajib diisi.",
  "auth.error.forgot.unauthorized-continue-uri":
    "URL lanjutan yang diberikan tidak diizinkan.",
  "auth.error.forgot.operation-not-allowed":
    "Reset kata sandi tidak diaktifkan untuk proyek ini.",

  // Firebase errors: setting the new password
  "auth.error.reset.invalid-action-code":
    "Kode tindakan tidak valid. Cek link-nya lalu coba lagi.",
  "auth.error.reset.expired-action-code":
    "Kode tindakan sudah kedaluwarsa. Minta email reset kata sandi yang baru.",
  "auth.error.reset.user-disabled":
    "Akun ini telah dinonaktifkan. Hubungi tim dukungan.",
  "auth.error.reset.user-not-found": "Tidak ada akun dengan email ini.",
  "auth.error.reset.weak-password": "Kata sandi minimal 6 karakter.",
  "auth.error.reset.operation-not-allowed":
    "Reset kata sandi tidak diaktifkan untuk proyek ini.",
  "auth.seo.loginTitle": "Masuk - Jammable",
  "auth.seo.loginDescription": "Masuk ke akun Jammable kamu.",
  "auth.seo.signupTitle": "Daftar | Jammable",
};

export default auth;
